/**
 * This file will configure various resources for your application.
 * - Logging to New Relic
 * - Analytics tracking through Adobe Target Events
 * - Daxi (The Origin Digital http request library)
 *
 * Anything else required before your app is loaded can be included in this
 * file.
 */

import {
  configAnalytics,
  configNewRelicLogger,
} from "@origin-digital/reporting-client";
import { configFetch, configFetchCache } from "@origin-digital/daxi";
import { config, appName } from "src/config";

declare const __DEV__: boolean;

const envAppName = `${appName}-${config.env}`;

configAnalytics({
  appName,
  debugToConsole: config.analyticsDebugToConsole,
});

configNewRelicLogger({
  apiKey:
    config.env === "staging" || config.env === "prod" ? undefined : "unused",
  appName: envAppName,
  consoleLogLevel: config.logLevelConsole as LogLevel,
  endpoint:
    config.env === "staging" || config.env === "prod"
      ? undefined
      : "/new-relic-disabled",
  logLevel: config.logLevelNewRelic as LogLevel,
  sendOnErrors: config.newRelicSendOnErrors,
  sourceEnv: config.env as EnvironmentNames,
});

/* eslint-disable-next-line no-undef */
configFetch({ disableAuthCheck: __DEV__ });
configFetchCache({ disableCache: __DEV__ });

if (__DEV__) {
  require("./mocks/eventDispatcherMocks");
  require("./mocks/optimizelyMocks");
}
